import axios, { CancelTokenSource } from "axios"
import { SumaSaldoInformeDtoIPagedEnumerableProps } from "./Schemas/SumaSaldoInformeDtoIPagedEnumerable"
import { SumaSaldoAdapter } from "./SumaSaldo.adapter"

interface SumaSaldoParams {
  CuentaContableGrupo?: number
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
  SoloCuentasConSaldo?: boolean
  SortingCriteria?: string
  TipoInformeSumaSaldo?: number
  FechaInicioMovimiento?: string
  FechaFinMovimiento?: string
  Keyword?: string
  TipoInforme?: number
}

// eslint-disable-next-line import/no-mutable-exports
export let SumaSaldoByFiltersCall: CancelTokenSource
export const getSumaSaldoByFilters = async (
  queryParams?: SumaSaldoParams
): Promise<SumaSaldoInformeDtoIPagedEnumerableProps> => {
  if (typeof SumaSaldoByFiltersCall !== typeof undefined) {
    SumaSaldoByFiltersCall.cancel("Previous Request Cancelled")
  }
  SumaSaldoByFiltersCall = axios.CancelToken.source()
  const { data }: { data: SumaSaldoInformeDtoIPagedEnumerableProps } =
    await axios.get(`SumaSaldo/by-filters/`, {
      params: queryParams,
      cancelToken: SumaSaldoByFiltersCall.token,
    })

  return {
    currentPage: data.currentPage,
    items: data.items?.map((impuesto) => SumaSaldoAdapter(impuesto)),
    totalCount: data.totalCount,
  }
}

export const generateSumaSaldoExcel = (queryParams?: SumaSaldoParams) => {
  return axios.get(`SumaSaldo/generate-excel`, {
    params: queryParams,
    responseType: "blob",
  })
}
